var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Jsonp, URLSearchParams } from '@angular/http';
// import { User } from '../models/user';
import { AppConfig } from '../../app.config';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
var UserService = /** @class */ (function () {
    function UserService(http, config, _jsonp) {
        this.http = http;
        this.config = config;
        this._jsonp = _jsonp;
    }
    UserService.prototype.createUser = function (user) {
        return this.http.post(this.config.apiUrl + 'user/create', user, this.setHeaders()).map(function (response) { return response.json(); });
    };
    UserService.prototype.forgotPassword = function (user) {
        return this.http.post(this.config.apiAuthUrl + 'user/forgot-password', user, this.setHeaders()).map(function (response) { return response.json(); });
    };
    UserService.prototype.resetPassword = function (user) {
        return this.http.post(this.config.apiUrl + 'user/change-password', user, this.setHeaders()).map(function (response) { return response.json(); });
    };
    UserService.prototype.getAll = function (userCurrentPage, maxSize, filter) {
        return this.http.post(this.config.apiUrl + 'user/get-all?page=' + userCurrentPage + '&limit=' + maxSize, filter, this.setHeaders()).map(function (response) { return response.json(); });
    };
    UserService.prototype.getPrecessor = function (request) {
        return this.http.post(this.config.apiUrl + 'user/get-precessor-by-role', request, this.setHeaders()).map(function (response) { return response.json(); });
    };
    UserService.prototype.getSuccessor = function (id) {
        return this.http.get(this.config.apiUrl + 'user/get-successor/' + id, this.setHeaders()).map(function (response) { return response.json(); });
    };
    UserService.prototype.deleteUser = function (id) {
        return this.http.put(this.config.apiUrl + 'user/delete', { id: id }, this.setHeaders()).map(function (response) { return response.json(); });
    };
    UserService.prototype.activateUser = function (id) {
        return this.http.put(this.config.apiUrl + 'user/activate', { id: id }, this.setHeaders()).map(function (response) { return response.json(); });
    };
    UserService.prototype.findById = function (id) {
        return this.http.post(this.config.apiUrl + 'user/findById', { id: id }, this.setHeaders()).map(function (response) { return response.json(); });
    };
    UserService.prototype.uploadPhoto = function () {
        return this.http.post(this.config.apiUrl + 'user/upload', this.setHeaders()).map(function (response) { return response.json(); });
    };
    UserService.prototype.getAllDocumentByUser = function (req) {
        return this.http.post(this.config.apiUrl + 'document/find-all-by-user', req, this.setHeaders()).map(function (response) { return response.json(); });
    };
    UserService.prototype.findAllDocument = function () {
        return this.http.post(this.config.apiUrl + 'document/find-all', {}, this.setHeaders()).map(function (response) { return response.json(); });
    };
    UserService.prototype.getAllSuccessor = function () {
        return this.http.get(this.config.apiUrl + 'user/get-all-successor/', this.setHeaders()).map(function (response) { return response.json(); });
    };
    UserService.prototype.replaceOwner = function (owner) {
        return this.http.post(this.config.apiUrl + 'owner/replace-owner', owner, this.setHeaders()).map(function (response) { return response.json(); });
    };
    UserService.prototype.replaceAccountOwner = function (owner, file) {
        return this.http.post(this.config.apiUrl + 'user/replace-account-manager?manager=' + owner.new_owner_bulk, file, this.setHeaders()).map(function (response) { return response.json(); });
    };
    UserService.prototype.updateUser = function (user) {
        return this.http.put(this.config.apiUrl + 'user/update', user, this.setHeaders()).map(function (response) { return response.json(); });
    };
    UserService.prototype.deleteDocument = function (id) {
        return this.http.get(this.config.apiUrl + 'document/delete/' + id, this.setHeaders());
    };
    UserService.prototype.exportCreditReport = function (userCurrentPage, maxSize, filter) {
        var params = new URLSearchParams();
        if (Object.keys(filter).length > 0) {
            for (var _i = 0, _a = Object.entries(filter); _i < _a.length; _i++) {
                var entries = _a[_i];
                var key = entries[0];
                var value = entries[1];
                if (entries[1]) {
                    params.append(key, value);
                }
            }
        }
        return this.http.get(this.config.apiUrl + 'user/credit-report?page=' + userCurrentPage + '&limit=' + maxSize, this.setHeaders(params))
            .map(function (response) { return response.json(); });
    };
    UserService.prototype.setHeaders = function (params) {
        // create authorization header with jwt token
        var token = localStorage.getItem('token');
        if (token) {
            // console.log('token >>>' + token);
            var headers = new Headers({ 'x-roamingse-token': token });
            if (params)
                return new RequestOptions({ headers: headers, search: params });
            else
                return new RequestOptions({ headers: headers });
        }
        else {
            return new RequestOptions({});
        }
    };
    UserService = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [Http, AppConfig, Jsonp])
    ], UserService);
    return UserService;
}());
export { UserService };



// WEBPACK FOOTER //
// /home/ec2-user/jenkins/workspace/new-roamingse/prod/roamingse-frontend/src/app/shared/services/user.service.ts.pre-build-optimizer.js